/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */

import React from "react";
import { Card } from "antd";
import "./stylescroll.css";
import { ForwardOutlined } from "@ant-design/icons";
import NoImage from "../../assets/no-image.jpg";
import "./HomePageStyles.css";
const link = "https://jerhrgroup.com/brochures/";
const ParentCard = ({ data }) => {
  const dataArray = Object.values(data || {});
  return (
    <Card
      title={
        <div className="moving-gradient-header">
          <span>BROCHURES & WHITE PAPERS</span>
        </div>
      }
      size="small"
      headStyle={{
        padding: 0,
        borderBottom: "none",
      }}
      bodyStyle={{
        padding: 16,
      }}
      style={{ borderRadius: 16, overflow: "hidden", maxHeight: "35vh" }}
    >
      <div
        className="scroll-container"
        style={{
          maxHeight: "30vh",

          //   overflowY: "auto", // Use scroll instead of auto
        }}
      >
        {dataArray?.map((item, index) => (
          <Card
            key={item.id}
            title={
              <div className="card-title-wrapper">
                <p className="card-title-text">{item.title}</p>
                <div className="custom-extra">
                  <a href={item?.link || link} target="_blank" rel="noreferrer">
                    Know more
                  </a>
                  <ForwardOutlined className="see-more-icon" />
                </div>
              </div>
            }
            className={`custom-card ${
              index % 2 === 0 ? "card-light-blue" : "card-light-gray"
            }`}
            hoverable
            size="small"
          >
            <div className="card-body">
              <div className="card-image-wrapper">
                <img
                  src={item.featured_image || NoImage}
                  alt={""}
                  className="card-image"
                />
              </div>
              <div className="card-content">
                <p className="card-description">{item.description}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </Card>
  );
};

export default ParentCard;
